import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, roles, requireProduction = false }) {
  const { user, productionId } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="text-zinc-400 text-sm tracking-widest uppercase">Preparing house lights…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  // super_admin bypasses every role gate — needed for cross-tenant impersonation.
  if (roles && user.role !== "super_admin" && !roles.includes(user.role)) {
    return <Navigate to="/productions" replace />;
  }
  if (requireProduction && !productionId && location.pathname !== "/productions") {
    return <Navigate to="/productions" replace />;
  }
  return children;
}
